import { httpClient } from '../httpClient'

export const getUserList = (filterData: any) => {
  const {
    PageNumber,
    PageSize,
    UserName,
    EmailAddress,
    Role,
    FirstName,
    userId,
  } = filterData

  return httpClient.get(
    `/v1/user?PageNumber=${PageNumber}&PageSize=${PageSize}` +
      (UserName !== '' ? `&UserName=${UserName}` : '') +
      (EmailAddress !== '' ? `&EmailAddress=${EmailAddress}` : '') +
      (FirstName !== '' ? `&FirstName=${FirstName}` : '') +
      (Role !== '' ? `&Role=${Role}` : '') +
      (userId !== '' ? `&userId=${userId}` : '')
  )
}

export const createUser = ({ payload }: any) => {
  return httpClient.post('/v1/user', payload)
}

export const editUser = ({ payload }: any) => {
  return httpClient.put('/v1/user', payload)
}

export const deleteUser = (UserName: any, id: any) => {
  return httpClient.delete(`/v1/user?UserName=${UserName}&UserId=${id}`)
}
